import { render, staticRenderFns } from "./PaymentNoteData.vue?vue&type=template&id=024c1b8d&scoped=true&"
import script from "./PaymentNoteData.vue?vue&type=script&lang=js&"
export * from "./PaymentNoteData.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNoteData.vue?vue&type=style&index=0&id=024c1b8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c1b8d",
  null
  
)

export default component.exports